import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  useTheme,
} from '@mui/material';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import UnsavedChangesWarningPopover from '../common/unsaved_changes_warning_popover';

const SharedContentBoardEditModal = ({ initialBoard, onSave, onDismiss }) => {
  const [title, setTitle] = useState(initialBoard.title);

  const [unsavedChangesWarningVisible, setUnsavedChangesWarningVisible] =
    useState(false);

  const [unsavedChangesWarningAnchorEl, setUnsavedChangesWarningAnchorEl] =
    useState(null);

  const onConfirmClose = () => {
    onDismiss();
  };

  const onDialogClose = (event, isClickAway) => {
    console.log({ isDirty });
    if (isDirty) {
      event.preventDefault();
      setUnsavedChangesWarningVisible(true);
      setUnsavedChangesWarningAnchorEl(isClickAway ? null : event.target);
    } else {
      onConfirmClose();
    }
  };

  const onDismissUnsavedChangesWarningPopover = () => {
    setUnsavedChangesWarningAnchorEl(null);
    setUnsavedChangesWarningVisible(false);
  };
  const theme = useTheme();

  const [isDirty, setIsDirty] = useState(false);

  const handleSave = () => {
    onSave({
      ...initialBoard,
      title,
    });
    setIsDirty(false);
  };

  return (
    <Dialog
      open
      maxWidth="sm"
      fullWidth
      onClose={(event) => onDialogClose(event, true)}>
      <DialogTitle className="content">
        <Box
          sx={{
            marginTop: '-15px',
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
          }}>
          <Tooltip title="Dismiss and return to board" placement="top-start">
            <IconButton
              aria-label="close"
              onClick={(event) => onDialogClose(event, false)}
              size="large">
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <div style={{ marginLeft: 10 }}>Edit content board</div>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <h5>Title</h5>
          </Grid>
          <Grid item xs={12} style={{ padding: '5px' }}>
            <TextField
              fullWidth
              variant="standard"
              value={title}
              autoFocus
              onChange={(ev) => {
                setTitle(ev.target.value);
                setIsDirty(true);
              }}
            />
          </Grid>
          <Grid item xs={12} style={{ margin: '15px 0', padding: '6px' }}>
            <Button
              variant="contained"
              onClick={handleSave}
              disabled={!isDirty}>
              Save
            </Button>
            <Button variant="contained" color="secondary" onClick={onDismiss}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      {unsavedChangesWarningVisible && (
        <UnsavedChangesWarningPopover
          anchorEl={unsavedChangesWarningAnchorEl}
          onConfirmClose={onConfirmClose}
          onDismiss={onDismissUnsavedChangesWarningPopover}
        />
      )}
    </Dialog>
  );
};

SharedContentBoardEditModal.propTypes = {
  initialBoard: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
  onSave: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default SharedContentBoardEditModal;
